import axios from "axios";

// Dynamic backend URL detection for custom domain support
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
export const API = `${BACKEND_URL}/api`;
export const AUTH_URL = process.env.REACT_APP_AUTH_URL || "https://auth.emergentagent.com";

export const axiosInstance = axios.create({
  withCredentials: true,
});

// Add JWT token to requests
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axiosInstance;
